export default __webpack_public_path__ + "static/media/locusofcontrol1Img1.807fb3bc.png";